import { all, takeEvery, takeLatest } from 'redux-saga/effects';

// #region WebhookEventsHeaders Types e sagas
import { Types as WebhookEventsHeaderTypes } from '../ducks/webhookEventHeaderIntegration';
import {
  deleteWebhookEventHeader,
  getWebhookEventHeadersList,
  postWebhookEventHeader,
  putWebhookEventHeader,
} from './webhookEventHeaderIntegration';
// #endregion WebhookEventsHeaders Types e sagas
// #region WebhookEvents Types e sagas
import { Types as WebhookEventsTypes } from '../ducks/webhookEventIntegration';
import {
  deleteWebhookEvent,
  getWebhookEventList,
  postWebhookEvent,
  putWebhookEvent,
} from './webhookEventIntegration';
// #endregion WebhookEvents Types e sagas

// #region Webhook Types e sagas
import { Types as WebhookTypes } from '../ducks/webhookIntegration';
import {
  deleteWebhook,
  getWebhookConfiguration,
  getWebhookEventsList,
  postWebhook,
  putWebhook,
} from './webhookIntegration';
// #endregion Webhook Types e sagas
// #region Auth Types e sagas
import { Types as AuthTypes } from '../ducks/auth';
import {
  getChangeToken,
  getRecuperarSenha,
  postLogin,
  postRecaptchaVerify,
  postRecuperarSenha,
  refreshInvalidToken,
  signIn,
  signOutLegado,
} from './auth';
// #endregion

// #region Lista Types e sagas
import { Types as ListaTypes } from '../ducks/lista';
import {
  criarLista,
  deleteLista,
  deleteListaCsv,
  getArquivoMassaInicial,
  getDownloadArquivoOriginalLote,
  getListaBeneficiario,
  getListaDetalhe,
  getListaGrupoFamiliar,
  getListaInativas,
  getListaMassaInicial,
  getListaPorStatus,
  getListaPorStatusRPA,
  getListas,
  getListasRPA,
  getRelatorioRPA,
  getStatusListAdmin,
  getStatusListContratante,
  getStatusListNestle,
  getStatusListRpa,
  getTermoResponsabilidadeMassaInicial,
  importarLote,
  importarLoteCsv,
  patchAceiteCompartilhamento,
  patchListaEnvioRPA,
  patchListaStatus,
  patchStatusRPA,
  patchValidacaoListaTransferencia,
  postArquivoImportacao,
  postArquivoImportacaoNestle,
  postArquivoMassaInicial,
  postFamiliar,
  postListaEnvioRPA,
  postListaInativas,
  postListaTransferencia,
  postRelatorioDetalhadoNovo,
  postRelatorioResumidoNovo,
  postSalvarBeneficiarioInativos,
  postSearchList,
  postSearchListRpa,
  putListaInativas,
  putListas,
  validarLoteCsv,
} from './lista';
// #endregion

// #region Modalidade Types e sagas
import { Types as ModalidadeTypes } from '../ducks/modalidade';
import { consultaModalidades } from './modalidade';
// #endregion

// #region Usuario Types e sagas
import { Types as UsuarioTypes } from '../ducks/usuario';
import {
  criarUsuario,
  getAndBuildParametrizacaoCards,
  getConsultaUsuarioPorStatus,
  getConsultaUsuarios,
  getContatoById,
  getContratantesUsuario,
  getDadosAcessoById,
  getHistoricoMovimentacoes,
  getParametrizacaoCards,
  getParametrizacaoCardsCompleto,
  getParametrizacaoNode,
  getParametrizacaoUsuario,
  getUsuarioById,
  getUsuarioEspelho,
  patchAtualizarTipoPerfil,
  patchDadosAcesso,
  patchDadosGerais,
  patchLiberarAcesso,
  patchParametrizacaoAdmInativar,
  patchParametrizacaoInativar,
  patchRegistrarContato,
  patchSenha,
  patchStatus,
  postAtualizarSessaoLegado,
  postClonarUsuarioEspelho,
  postParametrizacaoContratante,
  postParametrizacaoUsuario,
  putParametrizacaoUsuario,
  saveParametrizacaoCards,
} from './usuario';
// #endregion

// #region Contratante Types e sagas
import { Types as ContratanteTypes } from '../ducks/contratante';
import {
  getContratanteContagem,
  getContratanteModalidades,
  getContratantes,
  getGrupoComplementos,
  getGrupoContagem,
  getGrupoContratantes,
  getModalidadeTermos,
  getParametrizacaoContratanteCompleto,
  getParametrizacaoGrupoComplementoCompleto,
} from './contratante';
// #endregion

// #region ArquivoUpload Types e sagas
import { Types as ArquivoUpload } from '../ducks/arquivoUpload';
import {
  getArquivo,
  getAtualizacaoDeRelatorio,
  getListaArquivos,
} from './arquivoUpload';
// #endregion
// #region Requisicao Types e sagas
import { Types as RequisicaoTypes } from '../ducks/requisicao';
import {
  deleteSegundaVia,
  deleteSegundaViaAnexo,
  getBeneficiariosSegundaVia,
  getPermissaoSegundaVia,
  getSegundaViaAnexo,
  postSegundaViaBuscarPorId,
  postSegundaViaCartao,
  postSegundaViaProcessar,
  postSolicitarRelatorioSegundaVia,
  postSolicitarSegundaVia,
  putSegundaVia,
} from './requisicao';
// #endregion

// #region Beneficiario Types e sagas
import { Types as BeneficiarioTypes } from '../ducks/beneficiario';
import {
  getDocumentoDetalhe,
  getDocumentosStatus,
  patchDocumentoConferencia,
  postDataBeneficiriesNestle,
} from './beneficiario';
// #endregion
// #region Tasks Types e sagas
import { Types as TasksTypes } from '../ducks/task';
import { getUltimoErroTask, putReprocessarTask } from './task';
// #endregion

// #region Parametro Types e sagas
import { Types as ParametroTypes } from '../ducks/parametro';
import { getParametrosRequest, patchParametrosRequest } from './parametro';
// #endregion

// #region Relatorios Types e sagas
import { Types as RelatorioTypes } from '../ducks/relatorio';
import {
  getUltimoRelatorioNestle,
  postRelatorioBeneficiario,
  postRelatorioNestle,
} from './relatorio';
// #endregion

// #region Documentos Types e sagas
import { Types as DocumentoTypes } from '../ducks/documento';
import {
  getDocumentoPreview,
  getDocumentosBeneficiario,
  postAtualizarDocumentoConferencia,
  postDocumentosImportacao,
  postFinalizarConferenciaDocumentos,
} from './documento';

import { Types as ListaInativosTypes } from '../ducks/listaInativos';
import { putListaInativosAtualizarStatus } from './listaInativos';
// #endregion

export default function* rootSaga() {
  yield all([
    // #region webhookEventsHeaderIntegration
    takeLatest(
      WebhookEventsHeaderTypes.DELETE_WEBHOOK_EVENT_HEADER_REQUEST,
      deleteWebhookEventHeader
    ),
    takeLatest(
      WebhookEventsHeaderTypes.GET_WEBHOOK_EVENT_HEADERS_LIST_REQUEST,
      getWebhookEventHeadersList
    ),
    takeLatest(
      WebhookEventsHeaderTypes.POST_WEBHOOK_EVENT_HEADER_REQUEST,
      postWebhookEventHeader
    ),
    takeLatest(
      WebhookEventsHeaderTypes.PUT_WEBHOOK_EVENT_HEADER_REQUEST,
      putWebhookEventHeader
    ),
    // #endregion
    // #region webhookIntegration
    // #region webhookEventsIntegration
    takeLatest(
      WebhookEventsTypes.PUT_WEBHOOKEVENTINTEGRATION_REQUEST,
      putWebhookEvent
    ),
    takeLatest(
      WebhookEventsTypes.DELETE_WEBHOOKEVENTINTEGRATION_REQUEST,
      deleteWebhookEvent
    ),
    takeLatest(
      WebhookEventsTypes.GET_WEBHOOKEVENTSLISTINTEGRATION_REQUEST,
      getWebhookEventList
    ),
    takeLatest(
      WebhookEventsTypes.POST_WEBHOOKEVENTINTEGRATION_REQUEST,
      postWebhookEvent
    ),
    // #endregion
    // #region webhookIntegration
    takeLatest(
      WebhookTypes.GET_WEBHOOKINTEGRATION_LIST_EVENTS_REQUEST,
      getWebhookEventsList
    ),
    takeLatest(WebhookTypes.PUT_WEBHOOKINTEGRATION_REQUEST, putWebhook),
    takeLatest(WebhookTypes.DELETE_WEBHOOKINTEGRATION_REQUEST, deleteWebhook),
    takeLatest(
      WebhookTypes.GET_WEBHOOKINTEGRATION_CONFIGURATION_REQUEST,
      getWebhookConfiguration
    ),
    takeLatest(WebhookTypes.POST_WEBHOOKINTEGRATION_REQUEST, postWebhook),
    // #endregion
    // #region Auth
    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn),
    takeLatest(AuthTypes.REFRESH_INVALID_TOKEN_REQUEST, refreshInvalidToken),
    takeLatest(AuthTypes.GET_CHANGE_TOKEN_REQUEST, getChangeToken),
    takeLatest(AuthTypes.POST_LOGIN_REQUEST, postLogin),
    takeLatest(AuthTypes.POST_RECAPTCHA_VERIFY_REQUEST, postRecaptchaVerify),
    takeLatest(AuthTypes.POST_RECUPERAR_SENHA_REQUEST, postRecuperarSenha),
    takeLatest(AuthTypes.GET_RECUPERAR_SENHA_REQUEST, getRecuperarSenha),
    takeLatest(AuthTypes.SIGN_OUT_LEGADO_REQUEST, signOutLegado),
    // #endregion

    // #region Listas

    takeLatest(ListaTypes.GET_STATUS_LIST_NESTLE_REQUEST, getStatusListNestle),
    takeLatest(ListaTypes.DELETE_LISTA_CSV_REQUEST, deleteListaCsv),
    takeLatest(
      ListaTypes.GET_ARQUIVO_LOTE_ORIGINAL_REQUEST,
      getDownloadArquivoOriginalLote
    ),
    takeLatest(ListaTypes.POST_IMPORTAR_LOTE_CSV_REQUEST, importarLoteCsv),
    takeLatest(ListaTypes.POST_VALIDAR_LOTE_CSV_REQUEST, validarLoteCsv),
    takeLatest(
      ListaTypes.POST_RELATORIO_RESUMIDO_NOVO_REQUEST,
      postRelatorioResumidoNovo
    ),
    takeLatest(
      ListaTypes.POST_RELATORIO_DETALHADO_NOVO_REQUEST,
      postRelatorioDetalhadoNovo
    ),
    takeLatest(ListaTypes.GET_STATUS_LIST_RPA_REQUEST, getStatusListRpa),
    takeLatest(ListaTypes.GET_STATUS_LIST_ADMIN_REQUEST, getStatusListAdmin),
    takeLatest(ListaTypes.POST_SEARCH_LIST_REQUEST, postSearchList),
    takeLatest(ListaTypes.POST_SEARCH_LIST_RPA_REQUEST, postSearchListRpa),
    takeLatest(
      ListaTypes.GET_STATUS_LIST_CONTRATANTE_REQUEST,
      getStatusListContratante
    ),
    takeLatest(ListaTypes.GET_LISTAS_REQUEST, getListas),
    takeLatest(ListaTypes.GET_LISTAS_POR_STATUS_REQUEST, getListaPorStatus),
    takeLatest(
      ListaTypes.POST_ARQUIVO_IMPORTACAO_REQUEST,
      postArquivoImportacao
    ),
    takeLatest(ListaTypes.IMPORTAR_LOTE_REQUEST, importarLote),
    takeLatest(ListaTypes.PUT_LISTAS_REQUEST, putListas),
    takeLatest(ListaTypes.PATCH_LISTA_STATUS_REQUEST, patchListaStatus),
    takeLatest(ListaTypes.DELETE_LISTA_REQUEST, deleteLista),
    takeLatest(ListaTypes.PATCH_LISTA_ENVIO_RPA_REQUEST, patchListaEnvioRPA),
    takeLatest(ListaTypes.GET_LISTAS_RPA_REQUEST, getListasRPA),
    takeLatest(
      ListaTypes.GET_LISTAS_RPA_POR_STATUS_REQUEST,
      getListaPorStatusRPA
    ),
    takeLatest(ListaTypes.PATCH_STATUS_RPA_REQUEST, patchStatusRPA),
    takeLatest(ListaTypes.GET_RELATORIO_RPA_REQUEST, getRelatorioRPA),
    takeLatest(ListaTypes.GET_LISTA_DETALHE_REQUEST, getListaDetalhe),
    takeLatest(
      ListaTypes.GET_LISTA_MASSA_INICIAL_REQUEST,
      getListaMassaInicial
    ),
    takeLatest(
      ListaTypes.GET_ARQUIVO_MASSA_INICIAL_REQUEST,
      getArquivoMassaInicial
    ),
    takeLatest(
      ListaTypes.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_REQUEST,
      getTermoResponsabilidadeMassaInicial
    ),
    takeLatest(
      ListaTypes.POST_ARQUIVO_MASSA_INICIAL_REQUEST,
      postArquivoMassaInicial
    ),

    takeLatest(
      ListaTypes.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_REQUEST,
      patchValidacaoListaTransferencia
    ),
    takeLatest(
      ListaTypes.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_REQUEST,
      patchAceiteCompartilhamento
    ),
    takeLatest(
      ListaTypes.IMPORTAR_LOTE_NESTLE_REQUEST,
      postArquivoImportacaoNestle
    ),
    takeLatest(ListaTypes.POST_LISTA_INATIVAS_REQUEST, postListaInativas),
    takeLatest(ListaTypes.PUT_LISTA_INATIVAS_REQUEST, putListaInativas),
    takeLatest(ListaTypes.GET_LISTA_INATIVAS_REQUEST, getListaInativas),
    takeLatest(
      ListaTypes.GET_LISTA_BENEFICIARIOS_REQUEST,
      getListaBeneficiario
    ),
    takeLatest(
      ListaTypes.POST_SALVAR_BENEFICIARIO_INATIVOS_REQUEST,
      postSalvarBeneficiarioInativos
    ),
    takeLatest(ListaTypes.GET_GRUPO_FAMILIAR_REQUEST, getListaGrupoFamiliar),
    takeLatest(ListaTypes.POST_LISTA_FAMILIAR_REQUEST, postFamiliar),
    // #endregion

    // #region Modalidade
    takeLatest(ModalidadeTypes.GET_MODALIDADES_REQUEST, consultaModalidades),
    // #endregion

    // #region Usuario
    takeLatest(UsuarioTypes.GET_CONSULTA_USUARIOS_REQUEST, getConsultaUsuarios),
    takeLatest(
      UsuarioTypes.GET_CONSULTA_USUARIOS_POR_STATUS_REQUEST,
      getConsultaUsuarioPorStatus
    ),
    takeLatest(
      UsuarioTypes.PATCH_LIBERAR_ACESSO_USUARIO_REQUEST,
      patchLiberarAcesso
    ),
    takeLatest(UsuarioTypes.GET_USUARIO_BY_ID_REQUEST, getUsuarioById),
    takeLatest(UsuarioTypes.PATCH_STATUS_USUARIO_REQUEST, patchStatus),
    takeLatest(UsuarioTypes.CRIAR_USUARIO_REQUEST, criarUsuario),
    takeLatest(
      UsuarioTypes.PATCH_REGISTRAR_CONTATO_USUARIO_REQUEST,
      patchRegistrarContato
    ),
    takeLatest(UsuarioTypes.GET_CONTATO_BY_ID_REQUEST, getContatoById),
    takeLatest(UsuarioTypes.PATCH_SENHA_USUARIO_REQUEST, patchSenha),
    takeLatest(UsuarioTypes.GET_DADOS_ACESSO_BY_ID_REQUEST, getDadosAcessoById),
    takeLatest(UsuarioTypes.PATCH_DADOS_GERAIS_REQUEST, patchDadosGerais),
    takeLatest(UsuarioTypes.PATCH_DADOS_ACESSO_REQUEST, patchDadosAcesso),
    takeLatest(
      UsuarioTypes.GET_HISTORICO_MOVIMENTACOES_REQUEST,
      getHistoricoMovimentacoes
    ),
    takeLatest(
      UsuarioTypes.POST_PARAMETRIZACAO_CONTRATANTE_REQUEST,
      postParametrizacaoContratante
    ),
    takeLatest(
      UsuarioTypes.GET_PARAMETRIZACAO_USUARIO_REQUEST,
      getParametrizacaoUsuario
    ),
    takeLatest(
      UsuarioTypes.GET_CONTRATANTES_USUARIO_REQUEST,
      getContratantesUsuario
    ),
    takeLatest(
      UsuarioTypes.GET_PARAMETRIZACAO_CARDS_REQUEST,
      getParametrizacaoCards
    ),
    takeLatest(
      UsuarioTypes.POST_PARAMETRIZACAO_USUARIO_REQUEST,
      postParametrizacaoUsuario
    ),
    takeLatest(
      UsuarioTypes.PUT_PARAMETRIZACAO_USUARIO_REQUEST,
      putParametrizacaoUsuario
    ),
    takeEvery(
      UsuarioTypes.GET_PARAMETRIZACAO_NODE_REQUEST,
      getParametrizacaoNode
    ),
    takeLatest(
      UsuarioTypes.POST_ATUALIZAR_SESSAO_LEGADO_REQUEST,
      postAtualizarSessaoLegado
    ),
    takeLatest(
      UsuarioTypes.GET_PARAMETRIZACAO_CARD_COMPLETO_REQUEST,
      getParametrizacaoCardsCompleto
    ),
    takeLatest(
      UsuarioTypes.PATCH_PARAMETRIZACAO_INATIVAR_REQUEST,
      patchParametrizacaoInativar
    ),
    takeLatest(
      UsuarioTypes.PATCH_PARAMETRIZACAO_ADM_INATIVAR_REQUEST,
      patchParametrizacaoAdmInativar
    ),
    takeLatest(
      UsuarioTypes.SAVE_PARAMETRIZACAO_CARDS_REQUEST,
      saveParametrizacaoCards
    ),
    takeLatest(
      UsuarioTypes.GET_AND_BUILD_PARAMETRIZACAO_CARDS_REQUEST,
      getAndBuildParametrizacaoCards
    ),
    takeLatest(UsuarioTypes.GET_USUARIOS_ESPELHO_REQUEST, getUsuarioEspelho),
    takeLatest(
      UsuarioTypes.PATCH_ATUALIZAR_TIPO_PERFIL_REQUEST,
      patchAtualizarTipoPerfil
    ),
    takeLatest(
      UsuarioTypes.POST_CLONAR_USUARIO_ESPELHO_REQUEST,
      postClonarUsuarioEspelho
    ),
    // #endregion

    // #region Contratante
    takeLatest(
      ContratanteTypes.GET_GRUPO_COMPLEMENTOS_REQUEST,
      getGrupoComplementos
    ),
    takeLatest(ContratanteTypes.GET_CONTRATANTES_REQUEST, getContratantes),
    takeEvery(
      ContratanteTypes.GET_GRUPO_CONTRATANTES_REQUEST,
      getGrupoContratantes
    ),
    takeEvery(
      ContratanteTypes.GET_CONTRATANTE_MODALIDADES_REQUEST,
      getContratanteModalidades
    ),
    takeEvery(
      ContratanteTypes.GET_MODALIDADE_TERMOS_REQUEST,
      getModalidadeTermos
    ),
    takeEvery(ContratanteTypes.GET_GRUPO_CONTAGEM_REQUEST, getGrupoContagem),
    takeEvery(
      ContratanteTypes.GET_CONTRATANTE_CONTAGEM_REQUEST,
      getContratanteContagem
    ),

    // #region Requisicao
    takeLatest(
      RequisicaoTypes.GET_PERMISSAO_SEGUNDA_VIA_REQUEST,
      getPermissaoSegundaVia
    ),
    takeLatest(
      RequisicaoTypes.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_REQUEST,
      postSolicitarRelatorioSegundaVia
    ),
    takeLatest(
      RequisicaoTypes.POST_SOLICITAR_SEGUNDA_VIA_REQUEST,
      postSolicitarSegundaVia
    ),
    takeLatest(
      RequisicaoTypes.POST_BENEFICIARIOS_SEGUNDA_VIA_REQUEST,
      getBeneficiariosSegundaVia
    ),
    takeLatest(RequisicaoTypes.DELETE_SEGUNDA_VIA_REQUEST, deleteSegundaVia),
    takeLatest(
      RequisicaoTypes.DELETE_SEGUNDA_VIA_ANEXO_REQUEST,
      deleteSegundaViaAnexo
    ),
    takeLatest(
      RequisicaoTypes.GET_SEGUNDA_VIA_ANEXO_REQUEST,
      getSegundaViaAnexo
    ),
    takeLatest(RequisicaoTypes.PUT_SEGUNDA_VIA_UPDATE_REQUEST, putSegundaVia),
    takeLatest(
      RequisicaoTypes.POST_SEGUNDA_VIA_BUSCAR_POR_ID_REQUEST,
      postSegundaViaBuscarPorId
    ),
    takeLatest(
      RequisicaoTypes.POST_SEGUNDA_VIA_PROCESSAR_REQUEST,
      postSegundaViaProcessar
    ),
    takeLatest(
      RequisicaoTypes.POST_SEGUNDA_VIA_CARTAO_REQUEST,
      postSegundaViaCartao
    ),
    // #endregion

    // #region FileUpaload
    takeLatest(
      ArquivoUpload.GET_ATUALIZACAO_DE_RELATORIO_REQUEST,
      getAtualizacaoDeRelatorio
    ),
    takeLatest(ArquivoUpload.GET_ARQUIVO_REQUEST, getArquivo),
    takeLatest(ArquivoUpload.GET_LISTA_ARQUIVOS_REQUEST, getListaArquivos),

    // #endregion

    // #region Tasks

    takeLatest(
      TasksTypes.GET_TASK_DETAILS_LAST_ERROR_REQUEST,
      getUltimoErroTask
    ),
    takeLatest(TasksTypes.PUT_TASK_REPROCESS_REQUEST, putReprocessarTask),

    // #endregion

    // #region Beneficiario

    takeLatest(
      BeneficiarioTypes.POST_DATA_BENEFICIARIES_NESTLE_REQUEST,
      postDataBeneficiriesNestle
    ),
    takeLatest(
      BeneficiarioTypes.GET_DOCUMENTOS_STATUS_REQUEST,
      getDocumentosStatus
    ),
    takeLatest(
      BeneficiarioTypes.GET_DOCUMENTO_DETALHE_REQUEST,
      getDocumentoDetalhe
    ),
    takeLatest(
      BeneficiarioTypes.PATCH_DOCUMENTO_CONFERENCIA_REQUEST,
      patchDocumentoConferencia
    ),
    takeEvery(
      ContratanteTypes.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_REQUEST,
      getParametrizacaoGrupoComplementoCompleto
    ),
    takeEvery(
      ContratanteTypes.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_REQUEST,
      getParametrizacaoContratanteCompleto
    ),
    // #endregion

    // #region Parametrização
    takeLatest(ParametroTypes.GET_PARAMETROS_REQUEST, getParametrosRequest),
    takeLatest(ParametroTypes.PATCH_PARAMETRO_REQUEST, patchParametrosRequest),
    // #endregion

    // #region Relatorios
    takeLatest(
      RelatorioTypes.POST_RELATORIO_BENEFICIARIO_REQUEST,
      postRelatorioBeneficiario
    ),
    takeLatest(
      RelatorioTypes.POST_RELATORIO_NESTLE_REQUEST,
      postRelatorioNestle
    ),
    takeLatest(
      RelatorioTypes.GET_ULTIMO_RELATORIO_NESTLE_REQUEST,
      getUltimoRelatorioNestle
    ),
    // #endregion

    // #region Documentos
    takeLatest(
      DocumentoTypes.POST_DOCUMENTOS_IMPORTACAO_REQUEST,
      postDocumentosImportacao
    ),
    takeLatest(
      DocumentoTypes.GET_DOCUMENTOS_BENEFICIARIO_REQUEST,
      getDocumentosBeneficiario
    ),
    takeLatest(
      DocumentoTypes.GET_DOCUMENTO_PREVIEW_REQUEST,
      getDocumentoPreview
    ),
    takeLatest(
      DocumentoTypes.POST_ATUALIZAR_DOCUMENTO_CONFERENCIA_REQUEST,
      postAtualizarDocumentoConferencia
    ),
    takeLatest(
      DocumentoTypes.POST_FINALIZAR_CONFERENCIA_DOCUMENTOS_REQUEST,
      postFinalizarConferenciaDocumentos
    ),
    // #endregion

    // #region Lista Inativos
    takeLatest(
      ListaInativosTypes.PUT_LISTA_INATIVOS_ATUALIZAR_STATUS_REQUEST,
      putListaInativosAtualizarStatus
    ),
    // #endregion
  ]);
}
